const thirdPartyAssignment = [
  'Character Strengths Assessment',
  'Character & Personality Assessment',
  'Cognitive Ability Test',
];


export const isThirdPartyAssignment = (title) => thirdPartyAssignment.includes(String(title).trim())